import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import AdminDataTable from "../../components/common/AdminDataTable";
import AdminMemberLoginFilter from "./AdminMemberLoginFilter";
import { adminMemberLoginColumns } from "../../tables/adminMemberLoginColumns";

export default function AdminMemberLoginHistory() {
  const PAGE_SIZE = 10;
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";
  const token = localStorage.getItem("adminToken");

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalMembers, setTotalMembers] = useState(0);
  const [listLoading, setListLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    staff_name: "",
    profile_id: "",
    aadhar_verification: "",
    police_verification: "",
    photo_approval: "",
    caste_approval: "",
    education_approval: "",
    job_income_approval: "",
  });

  const fetchRecords = async (pageNumber = 1, activeFilters = filters, currentPageSize = pageSize) => {
    setListLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: pageNumber,
        limit: currentPageSize,
      });

      Object.entries(activeFilters).forEach(([key, value]) => {
        if (value) {
          queryParams.append(key, value);
        }
      });

      const response = await fetch(`${API_URL}/api/admin/member-login-history?${queryParams.toString()}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok || !data.status) {
        throw new Error(data.message || "Failed to fetch staff member login history");
      }

      setRecords(data.data.records || []);
      setTotalPages(data.data.pagination.total_pages || 1);
      setTotalRecords(data.data.pagination.total_records || 0);
      setTotalMembers(data.data.pagination.total_members || 0);
    } catch (error) {
      console.error("Staff member login history error:", error);
      setRecords([]);
      setTotalPages(1);
      setTotalRecords(0);
      setTotalMembers(0);
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    fetchRecords(page, filters, pageSize);
  }, [page, pageSize]);

  const handleFilter = (newFilters) => {
    setFilters(newFilters);
    setPage(1);
    fetchRecords(1, newFilters, pageSize);
  };

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Member Login History" />

        <div className="right_col" role="main">
          

          <div className="x_panel">
            <div className="x_title">
              <h2>Member Login Audit - Total Members: <strong>(  {totalMembers}  )</strong> | Total Records: <strong>( {totalRecords} )</strong></h2>
           
              <ul className="nav navbar-right panel_toolbox">
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>
              </ul>
              <div className="clearfix" />
            </div>

            <div className="x_content">
              <div className="row">
                <div className="col-sm-12">
                  <AdminMemberLoginFilter onFilter={handleFilter} />

                  <AdminDataTable
                    columns={adminMemberLoginColumns()}
                    data={records}
                    page={page}
                    pageSize={pageSize}
                    totalPages={totalPages}
                    loading={listLoading}
                    onPageChange={setPage}
                    onPageSizeChange={(size) => {
                      setPageSize(size);
                      setPage(1);
                    }}
                    sortBy="login_time"
                    sortOrder="desc"
                    onSort={() => {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}